/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { ApplicationFormPageService } from '../index';
import {
  CREATE_WORK_PERMIT,
  SAVE_APPLICATION,
  RESUBMIT_APPLICATION,
} from '@pages/ApplicationForm/api/graphql';
import humanizeString from 'humanize-string';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { workPermitConfig } from '../../config/workPermit.config';
import { toast } from 'react-hot-toast';
import { MarriageExemptiConfig } from '../../config/marriageExemption.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};
export interface IresubmitAppMethods extends IPluginMethodMap {
  resubmitApp(args: any): Promise<any>;
}

export interface ResubmitAppProps {}

export class resubmitAppService implements IAgentPlugin {
  readonly methods: IresubmitAppMethods;

  constructor() {
    this.methods = {
      resubmitApp: this.resubmitApp.bind(this),
    };
  }

  private async resubmitApp(args: any) {
    const srv = getSrv();

    console.log(`new Application service input data`, args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const storageSrv = StorageModule.getInstance();
    let _draftId = storageSrv.get('DRAFT_APP_ID', 'session');
    _draftId = _draftId ? { draftId: _draftId } : {};
    const whoAmI =
      userData?.currentRole ??
      (userData?.userRoles && Array.isArray(userData?.userRoles)
        ? userData?.userRoles[0]?.name
        : null);

    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`new Application service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      console.log(`new Application service client`, client);
      if (client) {
        if (args && Object.keys(args)?.length > 1) {
          console.log('argssss23', args);
          let _variables: any = {};
          if (
            args?.type === 'MARRIAGE_EXEMPTION' ||
            args?.type === 'RENEW_MARRIAGE_EXEMPTION'
          ) {
            _variables = this._getMarriageExceptionVariables(
              args,
              userData?.email,
              whoAmI
            );
          } else {
            _variables = this._getVariables(args, userData?.email, whoAmI);
          }
          console.log(`new Application service _variables`, _variables);
          const res = await client.mutation(RESUBMIT_APPLICATION, {
            ..._variables,
          });
          if (res?.data?.reSubmitApplication) {
            console.log(`data:: `, res?.data);
            //   storageSrv.set(
            //     'DRAFT_APP_ID',
            //     res?.data?.saveApplication?.applicationNo,
            //     'session'
            //   );
            return res?.data;
          }
        } else {
          toast.error('Failed to resubmit Application');
          throw 'Failed to resubmit Application';
        }
      }
    } catch (err: any) {
      console.log('error in activate User', err?.message);
      throw err;
    }
  }

  private getEmploymentInfo(data: any) {
    if (data?.employmentStatus === 'SELF_EMPLOYMENT') {
      const { selfAddress1, selfAddress2, selfCity, selfParish, selfCountry } =
        data;

      return {
        employmentStatus: data?.employmentStatus,
        selfEmployment: {
          address: {
            addressLine1: selfAddress1,
            addressLine2: selfAddress2,
            city: selfCity,
            parish: selfParish,
            country: selfCountry,
          },
          occupation: data?.selfOccupation,
        },
      };
    } else if (data?.employmentStatus === 'EMPLOYMENT') {
      const {
        employerName,
        employedAddress1,
        employedAddress2,
        employedCity,
        employedParish,
        employedCountry,
        employedTelephone,
        employedEmailAddress,
        employedNatureOfBusiness,
      } = data;
      return {
        employmentStatus: data?.employmentStatus,
        employment: {
          employerAddress: {
            addressLine1: employedAddress1,
            addressLine2: employedAddress2,
            city: employedCity,
            parish: employedParish,
            country: employedCountry,
          },
          email: employedEmailAddress,
          natureOfBusiness: employedNatureOfBusiness,
          primaryContactNo: employedTelephone,
          employerName,
        },
      };
    } else if (data?.employmentStatus === 'STUDENT') {
      const {
        educationType,
        degree,
        institutionName,
        institutionAddress,
        studentTelephone,
        studentEmailAddress,
      } = data;
      return {
        employmentStatus: data?.employmentStatus,
        student: {
          educationType,
          degreeOrCertificate: degree,
          primaryContactNo: studentTelephone,
          email: studentEmailAddress,
          institutionInfo: {
            nameOfInstitution: institutionName,
            addressOfInstitution: {
              addressLine1: institutionAddress,
            },
          },
        },
      };
    }
    return {};
  }

  private getEducationInfo(data: any) {
    const qualifications = data?.qualification;
    return qualifications?.map((qualification: any) => {
      return {
        dateOfIssued: qualification?.dateOfQualification,
        nameOfQualification: qualification?.qualificationName,
        highEducationQualification: data?.highEducationQualification,
        institutionInfo: {
          nameOfInstitution: qualification?.name,
          addressOfInstitution: {
            addressLine1: qualification?.address1,
            addressLine2: qualification?.address2,
            city: qualification?.city,
            parish: qualification?.parish,
            country: qualification?.country,
          },
        },
      };
    });
  }
  private getMarriageexemptionexpatriateDocuments(data: any) {
    let _documents: any[] = [];
    console.log(`new Application service getDocuments`, data);
    let dynamicDocs: any = {
      deadPoll: [
        {
          key: 'isNameChange',
          val: 'yes',
        },
        {
          key: 'nameChangeType',
          val: '1',
        },
      ],
      nameChange: [
        {
          key: 'isNameChange',
          val: 'yes',
        },
        {
          key: 'nameChangeType',
          val: '4',
        },
      ],
      financialStatement: {
        key: 'finCapable',
        val: 'yes',
      },
      birthCertificate: {
        key: 'citizenshipProof',
        val: 'bc',
      },
      natCertificate: {
        key: 'citizenshipProof',
        val: 'nc',
      },
      divorceCertificate: [
        {
          key: 'previouslyMarried',
          val: 'yes',
        },
        {
          key: 'divorcedOrWidowed',
          val: 'Divorced',
        },
      ],
      jamaicandivorceCertificate: [
        {
          key: 'jamaicanPreviouslyMarried',
          val: 'yes',
        },
        {
          key: 'jamaicanDivorcedOrWidowed',
          val: 'Divorced',
        },
      ],
    };
    MarriageExemptiConfig?.expatraiteDocuments &&
      Object.entries(MarriageExemptiConfig?.expatraiteDocuments).forEach(
        (ele) => {
          if (
            data[ele[0]] &&
            Array.isArray(data[ele[0]]) &&
            data[ele[0]].length > 0
          ) {
            let _docs: any[] = [];
            console.log(
              `new Application service getDocuments #1`,
              data[ele[0]]
            );
            const ans = data[ele[0]];
            let addOn = {};
            if (dynamicDocs?.[ele[0]]) {
              if (Array.isArray(dynamicDocs?.[ele[0]])) {
                dynamicDocs?.[ele[0]]?.forEach((item: any) => {
                  if (item?.val !== data?.[item?.key]) {
                    addOn = { operation: 'REMOVE' };
                  }
                });
              } else {
                if (
                  dynamicDocs?.[ele[0]]?.val !==
                  data?.[dynamicDocs?.[ele[0]]?.key]
                ) {
                  addOn = { operation: 'REMOVE' };
                }
              }
            }

            ans &&
              Array.isArray(ans) &&
              ans.length > 0 &&
              ans.forEach((e) => {
                _docs.push({
                  operation: e?.operation,
                  ...addOn,
                  name: e?.name,
                  type: ele[1],
                  src: e?.base64 ?? e?.src,
                  fileType: e?.type,
                });
              });

            // if (data[`expiry${ele[0]}`]) {
            //   //@ts-ignore
            //   res = { ...res, expiry: data[`expiry${ele[0]}`] };
            // }
            _documents = [..._documents, ..._docs];
          }
        }
      );
    return _documents;
  }
  private getMarriageexemptionJamaicanDocuments(data: any) {
    let _documents: any[] = [];
    console.log(`new Application service getDocuments`, data);
    let dynamicDocs: any = {
      deadPoll: [
        {
          key: 'isNameChange',
          val: 'yes',
        },
        {
          key: 'nameChangeType',
          val: '1',
        },
      ],
      nameChange: [
        {
          key: 'isNameChange',
          val: 'yes',
        },
        {
          key: 'nameChangeType',
          val: '4',
        },
      ],
      financialStatement: {
        key: 'finCapable',
        val: 'yes',
      },
      birthCertificate: {
        key: 'citizenshipProof',
        val: 'bc',
      },
      natCertificate: {
        key: 'citizenshipProof',
        val: 'nc',
      },
      divorceCertificate: [
        {
          key: 'previouslyMarried',
          val: 'yes',
        },
        {
          key: 'divorcedOrWidowed',
          val: 'Divorced',
        },
      ],
      jamaicandivorceCertificate: [
        {
          key: 'jamaicanPreviouslyMarried',
          val: 'yes',
        },
        {
          key: 'jamaicanDivorcedOrWidowed',
          val: 'Divorced',
        },
      ],
    };
    MarriageExemptiConfig?.jamaiacanDocuments &&
      Object.entries(MarriageExemptiConfig?.jamaiacanDocuments).forEach(
        (ele) => {
          if (
            data[ele[0]] &&
            Array.isArray(data[ele[0]]) &&
            data[ele[0]].length > 0
          ) {
            let _docs: any[] = [];
            console.log(
              `new Application service getDocuments #1`,
              data[ele[0]]
            );
            const ans = data[ele[0]];
            let addOn = {};
            if (dynamicDocs?.[ele[0]]) {
              if (Array.isArray(dynamicDocs?.[ele[0]])) {
                dynamicDocs?.[ele[0]]?.forEach((item: any) => {
                  if (item?.val !== data?.[item?.key]) {
                    addOn = { operation: 'REMOVE' };
                  }
                });
              } else {
                if (
                  dynamicDocs?.[ele[0]]?.val !==
                  data?.[dynamicDocs?.[ele[0]]?.key]
                ) {
                  addOn = { operation: 'REMOVE' };
                }
              }
            }

            ans &&
              Array.isArray(ans) &&
              ans.length > 0 &&
              ans.forEach((e) => {
                _docs.push({
                  operation: e?.operation,
                  ...addOn,
                  name: e?.name,
                  type: ele[1],
                  src: e?.base64 ?? e?.src,
                  fileType: e?.type,
                });
              });

            // if (data[`expiry${ele[0]}`]) {
            //   //@ts-ignore
            //   res = { ...res, expiry: data[`expiry${ele[0]}`] };
            // }
            _documents = [..._documents, ..._docs];
          }
        }
      );
    return _documents;
  }
  private getMarriageexemptionMarriageDocuments(data: any) {
    let _documents: any[] = [];
    console.log(`new Application service getDocuments`, data);
    let dynamicDocs: any = {
      deadPoll: [
        {
          key: 'isNameChange',
          val: 'yes',
        },
        {
          key: 'nameChangeType',
          val: '1',
        },
      ],
      nameChange: [
        {
          key: 'isNameChange',
          val: 'yes',
        },
        {
          key: 'nameChangeType',
          val: '4',
        },
      ],
      financialStatement: {
        key: 'finCapable',
        val: 'yes',
      },
      birthCertificate: {
        key: 'citizenshipProof',
        val: 'bc',
      },
      natCertificate: {
        key: 'citizenshipProof',
        val: 'nc',
      },
      divorceCertificate: [
        {
          key: 'previouslyMarried',
          val: 'yes',
        },
        {
          key: 'divorcedOrWidowed',
          val: 'Divorced',
        },
      ],
      jamaicandivorceCertificate: [
        {
          key: 'jamaicanPreviouslyMarried',
          val: 'yes',
        },
        {
          key: 'jamaicanDivorcedOrWidowed',
          val: 'Divorced',
        },
      ],
    };
    MarriageExemptiConfig?.marriageDocuments &&
      Object.entries(MarriageExemptiConfig?.marriageDocuments).forEach(
        (ele) => {
          if (
            data[ele[0]] &&
            Array.isArray(data[ele[0]]) &&
            data[ele[0]].length > 0
          ) {
            let _docs: any[] = [];
            console.log(
              `new Application service getDocuments #1`,
              data[ele[0]]
            );
            const ans = data[ele[0]];
            let addOn = {};
            if (dynamicDocs?.[ele[0]]) {
              if (Array.isArray(dynamicDocs?.[ele[0]])) {
                dynamicDocs?.[ele[0]]?.forEach((item: any) => {
                  if (item?.val !== data?.[item?.key]) {
                    addOn = { operation: 'REMOVE' };
                  }
                });
              } else {
                if (
                  dynamicDocs?.[ele[0]]?.val !==
                  data?.[dynamicDocs?.[ele[0]]?.key]
                ) {
                  addOn = { operation: 'REMOVE' };
                }
              }
            }

            ans &&
              Array.isArray(ans) &&
              ans.length > 0 &&
              ans.forEach((e) => {
                _docs.push({
                  operation: e?.operation,
                  ...addOn,
                  name: e?.name,
                  type: ele[1],
                  src: e?.base64 ?? e?.src,
                  fileType: e?.type,
                });
              });

            // if (data[`expiry${ele[0]}`]) {
            //   //@ts-ignore
            //   res = { ...res, expiry: data[`expiry${ele[0]}`] };
            // }
            _documents = [..._documents, ..._docs];
          }
        }
      );
    return _documents;
  }
  private getEmployerInfo(data: any) {
    if (data?.employmentStatus === 'EMPLOYED') {
      const {
        employerName,
        employedTelephone,
        employedEmailAddress,
        employedNatureOfBusiness,
      } = data;
      return {
        employerInfo: {
          email: employedEmailAddress,
          natureOfBusiness: employedNatureOfBusiness,
          primaryContactNo: employedTelephone,
          name: employerName,
        },
      };
    }
    return {};
  }

  private getApplicantEmploymentInfo(data: any) {
    if (data?.employmentStatus === 'SELF_EMPLOYED') {
      const { selfAddress1, selfAddress2, selfCity, selfParish, selfCountry } =
        data;
      return {
        employmentStatus: data?.employmentStatus,
        employmentAddress: {
          addressLine1: selfAddress1,
          addressLine2: selfAddress2,
          city: selfCity,
          parish: selfParish,
          country: selfCountry,
        },
        occupation: data?.selfOccupation,
      };
    } else if (data?.employmentStatus === 'EMPLOYED') {
      const {
        employerName,
        employedAddress1,
        employedAddress2,
        employedCity,
        employedParish,
        employedCountry,
      } = data;
      return {
        employmentStatus: data?.employmentStatus,
        employmentAddress: {
          addressLine1: employedAddress1,
          addressLine2: employedAddress2,
          city: employedCity,
          parish: employedParish,
          country: employedCountry,
        },

        nameOfEmployer: employerName,
      };
    } else if (data?.employmentStatus === 'STUDENT') {
      return {
        employmentStatus: data?.employmentStatus,
      };
    }
    return {};
  }
  private _getMarriageExceptionVariables = (
    data: any,
    createdBy: string,
    whoAmI: string
  ) => {
    console.log('vanten...', data);
    const expatriateDocuments =
      this.getMarriageexemptionexpatriateDocuments(data);
    const jamaicanDocuments = this.getMarriageexemptionJamaicanDocuments(data);
    const marriageDocuments = this.getMarriageexemptionMarriageDocuments(data);
    const storageSrv = StorageModule.getInstance();
    let _draftId = storageSrv.get('DRAFT_APP_ID', 'session');
    _draftId = _draftId ? { applicationNo: _draftId } : {};
    // console.log(`_documents`, _documents);
    let _data: any = {};
    //------only applicant Info is below------//
    _data = {
      input: {
        ..._draftId,
        ...this.getEmployerInfo(data),
        submit: data?.submit,
        updateProfile: false,
        type: data?.type,
        // educationInfo: this.getEducationInfo(data),
        // employmentInfo: this.getEmploymentInfo(data),

        applicantInfo: {
          ...this.getApplicantEmploymentInfo(data),
          firstName: data?.firstName || undefined,
          lastName: data?.lastName || undefined,
          middleName: data?.middleName || undefined,
          maidenName: data?.maidenName || undefined,
          dateOfBirth: data?.dateOfBirth || undefined,
          trn: data?.expatriateTrn || undefined,
          placeOfBirth: data?.placeOfBirth || undefined,
          nationality: data?.nationality || undefined,

          passportNumber: data?.expPassportNo || undefined,
          passportIssuanceDate: data?.passportIssuanceDate || undefined,
          passportExpiry: data?.passportExpiryDate || undefined,
          address: {
            addressLine1: data?.address1 || undefined,
            parish: data?.parish || undefined,
            city: data?.city || undefined,
          },
          email: data?.expEmail || undefined,
          primaryContactNo: data?.expPhoneNumber || undefined,
          gender: data?.gender || undefined,
          occupation: data?.expOccupation || undefined,
          previouslyMarried: data?.previouslyMarried === 'yes' ? true : false,
          refusedVisaOrDenied: data?.refusedVisa === 'yes' ? true : false,
          refusedJamaicanVisa:
            data?.refusedVisaJamaica === 'yes' ? true : false,
          criminalActivity: data?.criminalConvictions === 'yes' ? true : false,
          employed: data?.currentlyEmployed === 'yes' ? true : false,
          financiallyCapable: data?.finCapable === 'yes' ? true : false,
          divorceOrWidowed: data?.divorcedOrWidowed || undefined,
          refusedVisaOrDeniedReason: data?.refusedVisaDetails || undefined,
          refusionDetail:
            this.getRefusionDetail(data?.refusedvisadetail) || undefined,
          refusedJamaicanVisaReason:
            data?.refusedVisaJamaicaReason || undefined,
          criminalActivityReason: data?.ifCriminalConviction || undefined,
          salary: parseInt(data?.monthlySalary) || undefined,

          expatriateDocuments: expatriateDocuments,
        },

        jamaicanInfo: {
          jamaicanDocuments: jamaicanDocuments,
          firstName: data?.jamaicanFirstName || undefined,
          lastName: data?.jamaicanLastName || undefined,
          middleName: data?.jamaicanMiddleName || undefined,
          maidenName: data?.jamaicanMaidenName || undefined,
          placeOfBirth: data?.jamaicanPlaceOfBirth || undefined,
          nationality: data?.jamaicanNationality || undefined,
          // birthNaturalizationCertificateNo: data?.birthNaturalizationCertificateNo || undefined,
          citizenshipProof: data?.citizenshipProof || undefined,
          birthCertificateNo: data?.birthCertificateNo || undefined,
          NaturalizationCertificateNo:
            data?.naturalizationCertificateNo || undefined,
          typeOfIdentification: data?.typeOfIndentification || undefined,
          dateOfBirth: data?.jamaicanDateOfBirth || undefined,
          trn: data?.jamaicanTrn || undefined,
          NIS: data?.jamaicanNIS || undefined,
          gender: data?.jamaicanSex || undefined,
          occupation: data?.jamaicanOccupation || undefined,
          previouslyMarried:
            data?.jamaicanPreviouslyMarried === 'yes' ? true : false,
          employed: data?.jamaicanCurrentlyEmployed === 'yes' ? true : false,
          jamaicanEmployedState: data?.jamaicanEmployedState || undefined,
          salary: parseInt(data?.jamaicanMonthlySalary) || undefined,
          otherIncomeSource: data?.jamaicanOtherIncome || undefined,
          email: data?.jamaicanEmailAddress || undefined,
          primaryContactNo: data?.jamaicanContactNumber || undefined,
          financiallyCapable: data?.jamaicanFinCapable === 'yes' ? true : false,
          divorceOrWidowed: data?.jamaicanDivorcedOrWidowed || undefined,
          addressOfEmployer: {
            addressLine1: data?.addressOfEmployer || undefined,
          },
          address: {
            addressLine1: data?.jamaicanaddress1 || undefined,
            parish: data?.jamaicanparish || undefined,
            city: data?.jamaicancity || undefined,
          },
          jamaincaSpouseLiving: data?.jamaincaSpouseLiving || undefined,
        },
        marriageInfo: {
          marriageDocuments: marriageDocuments,

          marriageCertificateNo: data?.marriageCertificateNo || undefined,
          nameOfOfficer: data?.marriageOfficerName || undefined,
          groomName: data?.groomsName || undefined,
          brideName: data?.bridesName || undefined,
          placeOfMarriage: data?.placeOfMarriage || undefined,
          dateOfMarriage: data?.dateOfMarriage || undefined,
          addressOfCouple: {
            addressLine1: data?.addressOfCouple || undefined,
            city: data?.coupleCity || undefined,
            parish: data?.coupleParish || undefined,
          },
        },
      },
    };
    console.log('payload->', _data);
    return _data;
  };
  private _getVariables = (data: any, createdBy: string, whoAmI: string) => {
    console.log('var data123', data);
    const _documents = this.getDocuments(data);
    const storageSrv = StorageModule.getInstance();
    let _draftId = storageSrv.get('DRAFT_APP_ID', 'session');
    _draftId = _draftId ? { applicationNo: _draftId } : {};
    console.log(`_documents`, _documents);
    let _data: any = {};
    const occupation =
      data?.isOccupationChange === 'yes'
        ? data?._occupation && typeof data?._occupation?.id === 'string'
          ? `${data?._occupation?.id?.substring(1)}:${data?._occupation?.val}`
          : undefined
        : data?.occupation && typeof data?.occupation?.id === 'string'
        ? `${data?.occupation?.id?.substring(1)}:${data?.occupation?.val}`
        : undefined;

    if (data?.fillApplicantInfo) {
      _data = {
        input: {
          ..._draftId,
          // submit: true,
          // updateProfile: false,
          // applicant: data?.applicant,
          //applicant: '003',
          // type: data?.type,
          // educationInfo: this.getEducationInfo(data),
          // employmentInfo: this.getEmploymentInfo(data),
          applicantInfo: {
            firstName:
              data?.isFirstNameChange === 'yes'
                ? data?._firstName
                : data?.firstName,
            lastName:
              data?.isLastNameChange === 'yes'
                ? data?._lastName
                : data?.lastName,
            middleName:
              data?.isMiddleNameChange === 'yes'
                ? data?._middleInitial
                : data?.middleInitial,
            nationality:
              data?.isNationalityChange === 'yes'
                ? data?._nationality
                : data?.nationality,
            occupation: occupation,
            address: {
              addressLine1: data?.address1 ?? undefined,
              addressLine2: data?.address2 ?? undefined,
              addressLine3: data?.street ?? undefined,
              city: data?.city ?? undefined,
              country: data?.country ?? undefined,
              parish: data?.parish ?? undefined,
              state: undefined,
              zipcode: data?.postalCode ?? undefined,
            },
            isNameChange:
              data?.isNameChange === 'yes'
                ? true
                : data?.isNameChange === 'no'
                ? false
                : undefined,
            isMailingAddressSame:
              data?.isMailingAddressSame === 'yes'
                ? true
                : data?.isMailingAddressSame === 'no'
                ? false
                : undefined,
            isFirstNameChange:
              data?.isFirstNameChange === 'yes'
                ? true
                : data?.isFirstNameChange === 'no'
                ? false
                : undefined,
            isMiddleNameChange:
              data?.isMiddleNameChange === 'yes'
                ? true
                : data?.isMiddleNameChange === 'no'
                ? false
                : undefined,
            isOccupationChange:
              data?.isOccupationChange === 'yes'
                ? true
                : data?.isOccupationChange === 'no'
                ? false
                : undefined,
            isNationalityChange:
              data?.isNationalityChange === 'yes'
                ? true
                : data?.isNationalityChange == 'no'
                ? false
                : undefined,
            isPassportExpired:
              data?.isPassportExpired === 'yes'
                ? true
                : data?.isPassportExpired === 'no'
                ? false
                : undefined,
            isDependentExist:
              data?.isDependentExist === 'yes'
                ? true
                : data?.isDependentExist === 'no'
                ? false
                : undefined,
            destinationCarribbeanState:
              data?.destinationCarribbeanState ?? undefined,
            natureOfProfessionalActivity:
              data?.natureOfProfessionalActivity ?? undefined,
            alias: data?.alias ?? undefined,
            childrenOrDependent: data?.noOfChildren
              ? parseInt(data?.noOfChildren)
              : 0,
            countryConvicted: data?.countryConvicted ?? undefined,
            primaryContactNo: data?.userTelephoneNumber ?? undefined,
            criminalOffence: data?.criminalOffence === 'yes' ? true : false,
            dateOfBirth: data?.dateOfBirth ?? undefined,
            dateOfConviction: data?.dateOfConviction ?? undefined,
            natureOfOffence: data?.natureOfOffence ?? undefined,
            dependentInfo: this.getDependentInfo(data),
            gender: data?.gender,
            isLastNameExist: data?.isLastNameExist === 'yes' ? true : false,
            lastEmployer: {
              address: {
                addressLine1: data?.employerAddress1 ?? undefined,
                addressLine2: data?.employerAddress2 ?? undefined,
                addressLine3: data?.employerParish ?? undefined,
                city: data?.employerCity ?? undefined,
                country: undefined,
                parish: data?.employerParish ?? undefined,
                state: undefined,
                zipcode: undefined,
              },
              name: data?.nameOfEmployer ?? undefined,
              primaryContactNo: data?.telephoneOfEmployer ?? undefined,
              credentialNo: data?.workPermitNumber ?? undefined,
              wpExpiry: data?.workPermitExpiry ?? undefined,
            },
            email: data?.userEmail ?? undefined,
            maritalStatus: data?.maritalStatus ?? undefined,
            passportExpiry: data?.passportExpiry ?? undefined,
            passportNumber: data?.passport ?? undefined,
            natureOfBusiness: data?.userNatureOfBusiness ?? undefined,
            purposeOfRelocation: data?.purposeOfRelocation ?? undefined,
            passportType: data?.typeOfPassport ?? undefined,
            permissionPeriod: {
              from: data?.permitPeriodStart ?? undefined,
              to: data?.permitPeriodEnd ?? undefined,
            },
            placeOfBirth: data?.placeOfBirth ?? undefined,
            qualification: this.getQualification(data?.qualification),
            skills: data?.skills ?? undefined,
            spouseLastEmployer: {
              address: {
                addressLine1: data?.employerAddress1Dep ?? undefined,
                addressLine2: data?.employerAddress2Dep ?? undefined,
                addressLine3: undefined,
                city: data?.employerCityDep ?? undefined,
                country: undefined,
                parish: data?.employerParishDep ?? undefined,
                state: data?.employerStreetDep ?? undefined,
                zipcode: undefined,
              },
              name: data?.nameOfEmployerDep ?? undefined,
              primaryContactNo: data?.telephoneOfHusbandWife ?? undefined,
              credentialNo: data?.workPermitNumberDep ?? undefined,
              wpExpiry: data?.workPermitExpiryDep ?? undefined,
            },
            spouseName: data?.husbandOrWifeName ?? undefined,
            spouseNationality: data?.husbandOrWifeNationality ?? undefined,
            trn: data?.trn ?? undefined,
            workExperience: this.getWorkExperience(data),
            workedInJamaica: data?.workedInJamaica === 'yes' ? true : false,
          },
          documents: _documents,
          employerInfo: {
            address: {
              addressLine1: data?.businessAddress1 ?? undefined,
              addressLine2: data?.businessAddress2 ?? undefined,
              addressLine3: data?.businessStreet ?? undefined,
              city: data?.businessCity ?? undefined,
              country: data?.businessCountry ?? undefined,
              parish: data?.businessParish ?? undefined,
              state: undefined,
              zipcode: data?.businessPostalCode ?? undefined,
            },
            dateOfRegistration: data?.dateOfReg ?? undefined,
            email: data?.email ?? undefined,
            fax: data?.faxNumber ?? undefined,
            name: data?.businessName ?? undefined,
            natureOfBusiness: data?.natureOfBusiness ?? undefined,
            operatingAddress: {
              addressLine1:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessAddress1
                  : data?.mailingAddress1,
              addressLine2:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessAddress2
                  : data?.mailingAddress2,
              addressLine3:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessStreet
                  : data?.mailingStreet,
              city:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessCity
                  : data?.mailingCity,
              country: data?.businessCountry ?? undefined,
              parish:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessParish
                  : data?.mailingParish,
              state: undefined,
              zipcode:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessPostalCode
                  : data?.mailingPostalCode,
            },

            primaryContactNo: data?.telephoneNumber ?? undefined,
            saffCompsition: this.getStaffComposition(data),
            tccExpiryDate: data?.tccExpiryDate ?? undefined,
            tccNumber: data?.tccNumber ?? undefined,
            trn: data?.businessTrn ?? undefined,
            credentialNo: data?.workPermit ?? undefined,
          },
          jobInfo: {
            JobId: data?.jobId ?? undefined,
            JobTitle: data?.jobTitle ?? undefined,
            jobDuties: data?.jobDuties ?? undefined,
            allowances: {
              car: data?.car ? parseInt(data?.car) : 0,
              entertainment: data?.entertainment
                ? parseInt(data?.entertainment)
                : 0,
              house: data?.house ? parseInt(data?.house) : 0,
              other: data?.allowanceOther ? parseInt(data?.allowanceOther) : 0,
            },
            necessaryQualification: data?.qualifications ?? undefined,
            salaryOffered: data?.salaryOffered
              ? parseInt(data?.salaryOffered)
              : 0,
            registeredLMIS: data?.registeredLMIS === 'yes' ? true : false,
            workingHours: data?.workingHours ?? undefined,
            benefitsReceived: data?.benefitsReceived === 'yes' ? true : false,
            stepsForJaimacan: {
              byAdvertisement: data?.byAdvertisement === 'yes' ? true : false,
              didJamaicanApply: data?.didJamaicanApply === 'yes' ? true : false,
              appliedCandidates: data?.appliedCandidates
                ? parseInt(data?.appliedCandidates)
                : 0,
              reasonNoneHired: data?.reasonNoneHired ?? undefined,
              noStepTaken: data?.noStepTaken ?? undefined,

              internalRecruitment:
                data?.internalRecruitment === 'yes' ? true : false,
            },
          },
        },
      };
    } else if (whoAmI === 'prospective_employee') {
      _data = {
        input: {
          ..._draftId,
          updateProfile: false,
          applicant: data?.applicant,
          submit: true,
          type: data?.type,
          // educationInfo: this.getEducationInfo(data),
          // employmentInfo: this.getEmploymentInfo(data),
          applicantInfo: {
            firstName:
              data?.isFirstNameChange === 'yes'
                ? data?._firstName
                : data?.firstName,
            lastName:
              data?.isLastNameChange === 'yes'
                ? data?._lastName
                : data?.lastName,
            middleName:
              data?.isMiddleNameChange === 'yes'
                ? data?._middleInitial
                : data?.middleInitifal,
            nationality:
              data?.isNationalityChange === 'yes'
                ? data?._nationality
                : data?.nationality,
            occupation: occupation,
            isNameChange:
              data?.isNameChange === 'yes'
                ? true
                : data?.isNameChange === 'no'
                ? false
                : undefined,
            isMailingAddressSame:
              data?.isMailingAddressSame === 'yes'
                ? true
                : data?.isMailingAddressSame === 'no'
                ? false
                : undefined,
            isFirstNameChange:
              data?.isFirstNameChange === 'yes'
                ? true
                : data?.isFirstNameChange === 'no'
                ? false
                : undefined,
            isMiddleNameChange:
              data?.isMiddleNameChange === 'yes'
                ? true
                : data?.isMiddleNameChange === 'no'
                ? false
                : undefined,
            isOccupationChange:
              data?.isOccupationChange === 'yes'
                ? true
                : data?.isOccupationChange === 'no'
                ? false
                : undefined,
            isNationalityChange:
              data?.isNationalityChange === 'yes'
                ? true
                : data?.isNationalityChange == 'no'
                ? false
                : undefined,
            passportIssuanceDate: data?.passportIssuanceDate || undefined,

            isPassportExpired:
              data?.isPassportExpired === 'yes'
                ? true
                : data?.isPassportExpired === 'no'
                ? false
                : undefined,
            isDependentExist:
              data?.isDependentExist === 'yes'
                ? true
                : data?.isDependentExist === 'no'
                ? false
                : undefined,
            destinationCarribbeanState:
              data?.destinationCarribbeanState ?? undefined,
            natureOfBusiness: data?.userNatureOfBusiness ?? undefined,
            primaryContactNo: data?.userTelephoneNumber ?? undefined,
            address: {
              addressLine1: data?.address1 ?? undefined,
              addressLine2: data?.address2 ?? undefined,
              addressLine3: data?.street ?? undefined,
              city: data?.city ?? undefined,
              country: data?.country ?? undefined,
              parish: data?.parish ?? undefined,
              state: undefined,
              zipcode: data?.postalCode,
            },
            alias: data?.alias ?? undefined,
            childrenOrDependent: data?.noOfChildren
              ? parseInt(data?.noOfChildren)
              : 0,
            countryConvicted: data?.countryConvicted ?? undefined,
            criminalOffence: data?.criminalOffence === 'yes' ? true : false,
            dateOfBirth: data?.dateOfBirth ?? undefined,
            dateOfConviction: data?.dateOfConviction ?? undefined,
            natureOfOffence: data?.natureOfOffence ?? undefined,
            dependentInfo: this.getDependentInfo(data),
            email: data?.userEmail ?? undefined,
            gender: data?.gender,
            isLastNameExist: data?.isLastNameExist === 'yes' ? true : false,
            lastEmployer: {
              address: {
                addressLine1: data?.employerAddress1 ?? undefined,
                addressLine2: data?.employerAddress2 ?? undefined,
                addressLine3: data?.employerParish ?? undefined,
                city: data?.employerCity ?? undefined,
                country: undefined,
                parish: data?.employerParish ?? undefined,
                state: undefined,
                zipcode: undefined,
              },
              name: data?.nameOfEmployer ?? undefined,
              primaryContactNo: data?.telephoneOfEmployer ?? undefined,
              credentialNo: data?.workPermitNumber ?? undefined,
              wpExpiry: data?.workPermitExpiry ?? undefined,
            },
            natureOfProfessionalActivity:
              data?.natureOfProfessionalActivity ?? undefined,
            maritalStatus: data?.maritalStatus ?? undefined,
            purposeOfRelocation: data?.purposeOfRelocation ?? undefined,
            passportExpiry: data?.passportExpiry ?? undefined,
            passportNumber: data?.passport ?? undefined,
            passportType: data?.typeOfPassport ?? undefined,
            permissionPeriod: {
              from: data?.permitPeriodStart ?? undefined,
              to: data?.permitPeriodEnd ?? undefined,
            },
            placeOfBirth: data?.placeOfBirth ?? undefined,
            qualification: this.getQualification(data?.qualification),
            skills: data?.skills ?? undefined,
            spouseLastEmployer: {
              address: {
                addressLine1: data?.employerAddress1Dep ?? undefined,
                addressLine2: data?.employerAddress2Dep ?? undefined,
                addressLine3: undefined,
                city: data?.employerCityDep ?? undefined,
                country: undefined,
                parish: data?.employerParishDep ?? undefined,
                state: data?.employerStreetDep ?? undefined,
                zipcode: undefined,
              },
              name: data?.nameOfEmployerDep ?? undefined,
              primaryContactNo: data?.telephoneOfHusbandWife ?? undefined,
              credentialNo: data?.workPermitNumberDep ?? undefined,
              wpExpiry: data?.workPermitExpiryDep ?? undefined,
            },
            spouseName: data?.husbandOrWifeName ?? undefined,
            spouseNationality: data?.husbandOrWifeNationality ?? undefined,
            trn: data?.trn ?? undefined,
            workExperience: this.getWorkExperience(data),
            workedInJamaica: data?.workedInJamaica === 'yes' ? true : false,
          },
          documents: _documents,
        },
      };
    } else {
      _data = {
        input: {
          ..._draftId,
          updateProfile: false,
          applicant: data?.applicant,
          type: data?.type,
          inviteApplicant: true,
          submit: true,
          documents: _documents,
          employerInfo: {
            address: {
              addressLine1: data?.businessAddress1 ?? undefined,
              addressLine2: data?.businessAddress2 ?? undefined,
              addressLine3: data?.businessStreet ?? undefined,
              city: data?.businessCity ?? undefined,
              country: data?.businessCountry ?? undefined,
              parish: data?.businessParish ?? undefined,
              state: undefined,
              zipcode: data?.businessPostalCode ?? undefined,
            },
            country: undefined,
            dateOfRegistration: data?.dateOfReg ?? undefined,
            declaration: {
              selected: undefined,
              value: undefined,
            },
            description: undefined,
            email: data?.email ?? undefined,
            fax: data?.faxNumber ?? undefined,
            incorporationDate: undefined,
            isSubsidiary: undefined,
            logo: undefined,
            name: data?.businessName ?? undefined,
            natureOfBusiness: data?.natureOfBusiness ?? undefined,
            operatingAddress: {
              addressLine1:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessAddress1
                  : data?.mailingAddress1,
              addressLine2:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessAddress2
                  : data?.mailingAddress2,
              addressLine3:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessStreet
                  : data?.mailingStreet,
              city:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessCity
                  : data?.mailingCity,
              country: data?.businessCountry ?? undefined,
              parish:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessParish
                  : data?.mailingParish,
              state: undefined,
              zipcode:
                data?.isMailingAddressSame === 'yes'
                  ? data?.businessPostalCode
                  : data?.mailingPostalCode,
            },

            primaryContactNo: data?.telephoneNumber ?? undefined,
            saffCompsition: this.getStaffComposition(data),
            tccExpiryDate: data?.tccExpiryDate ?? undefined,
            tccNumber: data?.tccNumber ?? undefined,
            trn: data?.businessTrn ?? undefined,
            credentialNo: data?.workPermit ?? undefined,
          },
          jobInfo: {
            JobId: data?.jobId ?? undefined,
            JobTitle: data?.jobTitle ?? undefined,
            jobDuties: data?.jobDuties ?? undefined,
            allowances: {
              car: data?.car ? parseInt(data?.car) : 0,
              entertainment: data?.entertainment
                ? parseInt(data?.entertainment)
                : 0,
              house: data?.house ? parseInt(data?.house) : 0,
              other: data?.allowanceOther ? parseInt(data?.allowanceOther) : 0,
            },
            necessaryQualification: data?.qualifications ?? undefined,
            salaryOffered: data?.salaryOffered
              ? parseInt(data?.salaryOffered)
              : 0,
            registeredLMIS: data?.registeredLMIS === 'yes' ? true : false,
            workingHours: data?.workingHours ?? undefined,
            benefitsReceived: data?.benefitsReceived === 'yes' ? true : false,
            stepsForJaimacan: {
              byAdvertisement: data?.byAdvertisement === 'yes' ? true : false,
              didJamaicanApply: data?.didJamaicanApply === 'yes' ? true : false,
              appliedCandidates: data?.appliedCandidates
                ? parseInt(data?.appliedCandidates)
                : 0,
              reasonNoneHired: data?.reasonNoneHired ?? undefined,
              noStepTaken: data?.noStepTaken ?? undefined,

              internalRecruitment:
                data?.internalRecruitment === 'yes' ? true : false,
            },
          },
        },
      };
    }

    return _data;
  };

  private getStaffComposition = (data: any) => {
    let _staffComposition: any = [];
    for (let i = 0; i < 4; i++) {
      if (i === 0) {
        _staffComposition.push({
          citizenship: 'JAMAICAN',
          professional: data?.jamaicanProfessional
            ? parseInt(data?.jamaicanProfessional)
            : 0,
          elementaryOccupations: data?.jamaicanElementary
            ? parseInt(data?.jamaicanElementary)
            : 0,
          skilledWorkers: data?.jamaicanSkilledWorkers
            ? parseInt(data?.jamaicanSkilledWorkers)
            : 0,
          clerksOrServiceWorker: data?.jamaicanClerks
            ? parseInt(data?.jamaicanClerks)
            : 0,
          plantAndMachineOperators: data?.jamaicanPlant
            ? parseInt(data?.jamaicanPlant)
            : 0,
        });
      } else if (i === 1) {
        _staffComposition.push({
          citizenship: 'CARRICOM',
          professional: data?.carricomProfessional
            ? parseInt(data?.carricomProfessional)
            : 0,
          elementaryOccupations: data?.carricomElementary
            ? parseInt(data?.carricomElementary)
            : 0,
          skilledWorkers: data?.carricomSkilledWorkers
            ? parseInt(data?.carricomSkilledWorkers)
            : 0,
          clerksOrServiceWorker: data?.carricomClerks
            ? parseInt(data?.carricomClerks)
            : 0,
          plantAndMachineOperators: data?.carricomPlant
            ? parseInt(data?.carricomPlant)
            : 0,
        });
      } else if (i === 2) {
        _staffComposition.push({
          citizenship: 'COMMON_WEALTH',
          professional: data?.commonWealthProfessional
            ? parseInt(data?.commonWealthProfessional)
            : 0,
          elementaryOccupations: data?.commonWealthElementary
            ? parseInt(data?.commonWealthElementary)
            : 0,
          skilledWorkers: data?.commonWealthSkilledWorkers
            ? parseInt(data?.commonWealthSkilledWorkers)
            : 0,
          clerksOrServiceWorker: data?.commonWealthClerks
            ? parseInt(data?.commonWealthClerks)
            : 0,
          plantAndMachineOperators: data?.commonWealthPlant
            ? parseInt(data?.commonWealthPlant)
            : 0,
        });
      } else if (i === 3) {
        _staffComposition.push({
          citizenship: 'FOREGION',
          professional: data?.foreignProfessional
            ? parseInt(data?.foreignProfessional)
            : 0,
          elementaryOccupations: data?.foreignElementary
            ? parseInt(data?.foreignElementary)
            : 0,
          skilledWorkers: data?.foreignSkilledWorkers
            ? parseInt(data?.foreignSkilledWorkers)
            : 0,
          clerksOrServiceWorker: data?.foreignClerks
            ? parseInt(data?.foreignClerks)
            : 0,
          plantAndMachineOperators: data?.foreignPlant
            ? parseInt(data?.foreignPlant)
            : 0,
        });
      }
    }
    return _staffComposition;
  };

  private getDocuments(data: any) {
    let _documents: any[] = [];
    console.log(`new Application service getDocuments`, data);
    workPermitConfig?.availableDocuments &&
      Object.entries(workPermitConfig?.availableDocuments).forEach((ele) => {
        if (
          data[ele[0]] &&
          Array.isArray(data[ele[0]]) &&
          data[ele[0]].length > 0
        ) {
          let _docs: any[] = [];
          console.log(`new Application service getDocuments #1`, data[ele[0]]);
          const ans = data[ele[0]];
          ans &&
            Array.isArray(ans) &&
            ans.length > 0 &&
            ans.forEach((e) => {
              _docs.push({
                name: e?.name,
                type: ele[1],
                src: e?.base64 ?? e?.src,
                fileType: e?.type,
              });
            });

          // if (data[`expiry${ele[0]}`]) {
          //   //@ts-ignore
          //   res = { ...res, expiry: data[`expiry${ele[0]}`] };
          // }
          _documents = [..._documents, ..._docs];
        }
      });
    return _documents;
  }

  private getDependentInfo(data: any) {
    let _dependentInfo: any[] = [];
    console.log(
      `workPermitApp service getDependentInfo`,
      data?.dependentInfo,
      data
    );
    data &&
      Array.isArray(data?.dependentInfo) &&
      data?.dependentInfo.length > 0 &&
      data?.dependentInfo.forEach((e: any) => {
        let ans: any = {
          documents: [],
        };
        if (e?.dependentType === 'MINOR_CHILD') {
          if (
            e?.certifyBirth &&
            (e?.certifyBirth?.[0]?.base64 ?? e?.certifyBirth?.[0]?.src)
          ) {
            ans['documents'].push({
              name: e?.certifyBirth?.[0]?.name,
              type: 'CERTIFIED_COPY_OF_BIRTH_CERTIFICATE',
              src: e?.certifyBirth?.[0]?.base64 ?? e?.certifyBirth?.[0]?.src,
              fileType: e?.certifyBirth?.[0]?.type,
            });
          }
          if (
            e?.passportProof &&
            (e?.passportProof?.[0]?.base64 ?? e?.passportProof?.[0]?.src)
          ) {
            ans['documents'].push({
              name: e?.passportProof?.[0]?.name,
              type: 'PASSPORT_PROOF',
              src: e?.passportProof?.[0]?.base64 ?? e?.passportProof?.[0]?.src,
              fileType: e?.passportProof?.[0]?.type,
            });
          }
          if (
            e?.adoption &&
            (e?.adoption?.[0]?.base64 ?? e?.adoption?.[0]?.src)
          ) {
            ans['documents'].push({
              name: e?.adoption?.[0]?.name,
              type: 'ADOPTION_CERTIFICATE_PROOF',
              src: e?.adoption?.[0]?.base64 ?? e?.adoption?.[0]?.src,
              fileType: e?.adoption?.[0]?.type,
            });
          }
        }
        _dependentInfo.push({
          ...ans,
          dependentType: e?.dependentType ?? undefined,
          name: e?.dependentName ?? undefined,
          age: e?.dependentAge ? parseInt(e?.dependentAge) : undefined,
          gender: e?.dependentSex ?? undefined,
          nationality: e?.dependentNationality ?? undefined,
          relationship: e?.dependentRelationship ?? undefined,
          passportNumber: e?.dependentPassport ?? undefined,
        });
      });
    return _dependentInfo;
  }
  private getRefusionDetail(data: any) {
    let result = [];
    console.log('payloadaftersubmit-->realpayload', data);
    result =
      data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((e: any) => {
        return {
          country: e.refusedVisaCountry,
          reason: e.refusedVisaReason,
        };
      });
    return result;
  }
  private getWorkExperience(data: any) {
    let _workExperience: any[] = [];
    console.log(
      `test#123new Application service getWorkExperience`,
      data?.workExperience
    );
    data &&
      Array.isArray(data?.workExperience) &&
      data?.workExperience.length > 0 &&
      data?.workExperience.forEach((ele: any) => {
        _workExperience.push({
          from: ele?.wePeriodStart,
          to: ele?.wePeriodEnd,
          jobDuty: ele?.jobDutyType,
          nameOfOrganization: ele?.organizationName,
        });
      });
    return _workExperience;
  }

  private getQualification(data: any) {
    let _qualification: any[] = [];
    console.log(`new Application service getQualification`, data);
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.forEach((ele: any) => {
        _qualification.push({
          degree: humanizeString(ele?.qualificationName),
          from: ele?.dateOfQualification,
        });
      });
    return _qualification;
  }
}
